// 页面组件
import Home from '../pages/home';
import Login from '../pages/user/login1';
import Callback from '../pages/user/callback';
import ImageLogin from '../pages/img/login';
import UploadImage from '../pages/img/upload';
import ImageScraperUploader from '../pages/ImageScraperUploader';
import CryptoPage from '../pages/crypto';
import ContentReview from '../pages/content-review';
import ReportPage from '../pages/report';
import ViewPage from '@/pages/report/ViewPage';
import JudgePage from '@/pages/report/JudgePage';
import DetailPage from '@/pages/content-review/DetailPage';
import SuggestionPage from '@/pages/suggestion';
import CheckPage from '@/pages/suggestion/CheckPage';
import UserMng from '@/pages/user-mng';
import UserDetailPage from '@/pages/user-mng/detai';
import ExhibitionPage from '@/pages/exhibition';
import ExhibitionEditor from '@/pages/exhibition/editor';
import ExhibitionComment from '@/pages/exhibition/comment';
import PictureFramePage from '@/pages/picture-frame';
import FrameDetailPage from '@/pages/picture-frame/frameDetail';
import ArtworkVerify from '../pages/artworkVerify';
import VerifyDetail from '../pages/artworkVerify/verifyDetail';
import ArtistAboutPage from '../pages/artistAbout';
import ArtistAboutEditor from '../pages/artistAbout/editor';
import ArtistVerifyPage from '../pages/artistVerify';
import ActionPanelPage from '../pages/artistVerify/actionPanel';
import ActivityMngPage from '../pages/activityMng';
import ActivityEditorPage from '../pages/activityMng/editor';
import NoPermissionPage from '../pages/403';
import PointsMallPage from '../pages/points-mall';
import PointsMallDetail from '../pages/points-mall/detail';
import UserRegisterPage from '../pages/user-register';
import UserPointsPage from '@/pages/user-points';
import UserCoinsPage from '@/pages/user-coins';
import { RouteConfig } from '@/types/route';
import { PageLink } from './pageConfig';
import ResourceMaterialPage from '@/pages/resource-material';
import ResourceMaterialDetailPage from '@/pages/resource-material/detail';
import ResourcePositionPage from '@/pages/resource-position';
import TopicMngPage from '@/pages/topicMng';
import TopicMngEditorPage from '@/pages/topicMng/editor';
import CommunityTopicMngPage from '@/pages/community/topic-mng';
import CommunityTopicSubmissionsPage from '@/pages/community/topic-mng/submissions';
import ForbiddenWordPage from '@/pages/community/forbidden-word';
import VersionMngPage from '@/pages/version';
import VersionMngIosPage from '@/pages/version/ios';
import VersionMngAndroidPage from '@/pages/version/android';
import VoteActivitySubmissions from '@/pages/vote-activity/vote/submissions';
import VoteActivityPage from '@/pages/vote-activity';
import VoteActivityCreate from '@/pages/vote-activity/vote/create';
import ProductsPage from '@/pages/products';
import ProductsCreate from '@/pages/products/create';
import ProductsEdit from '@/pages/products/edit';
import ProductsDetail from '@/pages/products/detail';
import OrderPage from '@/pages/order';
import RechargePage from '@/pages/order/Recharge';
import Improper from '@/pages/content-review/Improper';

import PushMngPage from '@/pages/push';
import PushMngDetailPage from '@/pages/push/detail';

import RecallPage from '@/pages/recall';
import RecallCreatePage from '@/pages/recall/create';
import RecallDetailPage from '@/pages/recall/detail';
import LotteryActivityPage from '@/pages/lottery-activity';
import LotteryActivityCreate from '@/pages/lottery-activity/create';
import LotteryActivityRecord from '@/pages/lottery-activity/record';
import PromptUploadPage from '@/pages/promptUpload';
import BannerMngPage from '@/pages/banner/index';
import BannerMngDetailPage from '@/pages/banner/detail';
import LiblibList from '@/pages/liblib/index';
import LiblibDetail from '@/pages/liblib/detail';

import ConvertList from '@/pages/convert';
import ConvertDetail from '@/pages/convert/detail'

import NoticeConfig from '@/pages/notice-config';
import NoticeConfigEdit from '@/pages/notice-config/create';
import NoticeConfigDetail from '@/pages/notice-config/detail';
import MemberTypePage from '@/pages/member/type';
import MemberBenefitPage from '@/pages/member/benefit';
import MemberSubscriptionPage from '@/pages/member/subscription';
import VipSuppIdPage from '@/pages/member/suppid';
import NewcomerChallengePage from '@/pages/member/newcomer-challenge';
import NewcomerChallengeDetailPage from '@/pages/member/newcomer-challenge/detail';
import NewcomerChallengeSubmissionsPage from '@/pages/member/newcomer-challenge/submissions';
import ActivityRulesPage from '@/pages/member/activity-rules';
import ActivityRuleDetailPage from '@/pages/member/activity-rules/detail';
import TextToImageStylePage from '@/pages/text-to-image/style';
import LimitedTaskMngPage from '@/pages/task-mng';
/**
 * 路由配置
 * 只包含路由组件映射和基本配置，不包含菜单相关的配置
 * 菜单结构由后端接口返回
 */
export const ROUTES_CONFIG: RouteConfig[] = [
  // 基础路由（无需权限）
  {
    path: PageLink.Home,
    element: <Home />,
    noPermissionRequired: true,
    label: '首页',
  },
  {
    path: PageLink.Login,
    element: <Login />,
    noLayout: true,
    hideInMenu: true,
    noPermissionRequired: true,
  },
  {
    path: PageLink.Callback,
    element: <Callback />,
    noLayout: true,
    hideInMenu: true,
    noPermissionRequired: true,
  },
  {
    path: PageLink.ImgLogin,
    element: <ImageLogin />,
    noLayout: true,
    hideInMenu: true,
    noPermissionRequired: true,
  },
  {
    path: '/403',
    element: <NoPermissionPage />,
    hideInMenu: true,
    noPermissionRequired: true,
    label: '403',
  },

  // 内容管理
  {
    path: PageLink.ContentReview,
    element: <ContentReview />,
  },
  {
    path: PageLink.ContentReviewDetail,
    element: <DetailPage />,
    hideInMenu: true,
  },

  // 内容举报
  {
    path: PageLink.Report,
    element: <ReportPage />,
  },
  {
    path: PageLink.ReportView,
    element: <ViewPage />,
    hideInMenu: true,
  },
  {
    path: PageLink.ReportJudge,
    element: <JudgePage />,
    hideInMenu: true,
  },

  // 产品反馈
  {
    path: PageLink.Suggestion,
    element: <SuggestionPage />,
  },
  {
    path: PageLink.SuggestionCheck,
    element: <CheckPage />,
    hideInMenu: true,
  },

  // 用户管理
  {
    path: PageLink.UserMng,
    element: <UserMng />,
  },
  {
    path: PageLink.UserMngDetail,
    element: <UserDetailPage />,
    hideInMenu: true,
  },
  {
    path: PageLink.UserPoints,
    element: <UserPointsPage />,
    hideInMenu: true,
  },
  {
    path: PageLink.UserCoins,
    element: <UserCoinsPage />,
    hideInMenu: true,
  },
  {
    path: PageLink.UserRegister,
    element: <UserRegisterPage />,
  },

  // 展览内容管理
  {
    path: PageLink.Exhibition,
    element: <ExhibitionPage />,
  },
  {
    path: PageLink.ExhibitionEditor,
    element: <ExhibitionEditor />,
    hideInMenu: true,
  },
  {
    path: PageLink.ExhibitionComment,
    element: <ExhibitionComment />,
    hideInMenu: true,
  },
  // 画框审核
  {
    path: PageLink.PictureFrame,
    element: <PictureFramePage />,
  },
  {
    path: PageLink.PictureFrameDetail,
    element: <FrameDetailPage />,
    hideInMenu: true,
  },

  // 学校认证
  {
    path: PageLink.ArtworkVerify,
    element: <ArtworkVerify />,
  },
  {
    path: PageLink.ArtworkVerifyDetail,
    element: <VerifyDetail />,
    hideInMenu: true,
  },

  // 艺术家认证
  {
    path: PageLink.ArtistVerify,
    element: <ArtistVerifyPage />,
  },
  {
    path: PageLink.ArtistVerifyDetail,
    element: <ActionPanelPage />,
    hideInMenu: true,
  },

  // 艺术家介绍
  {
    path: PageLink.ArtistAbout,
    element: <ArtistAboutPage />,
  },
  {
    path: PageLink.ArtistAboutEditor,
    element: <ArtistAboutEditor />,
    hideInMenu: true,
  },

  // 活动管理
  {
    path: PageLink.ActivityMng,
    element: <ActivityMngPage />,
  },
  {
    path: PageLink.ActivityMngEditor,
    element: <ActivityEditorPage />,
    hideInMenu: true,
  },
  // 话题管理（原有）
  {
    path: PageLink.TopicMng,
    element: <TopicMngPage />,
  },
  {
    path: PageLink.TopicMngEditor,
    element: <TopicMngEditorPage />,
    hideInMenu: true,
  },
  // 社区管理
  // 社区管理 - 话题管理
  {
    path: PageLink.CommunityTopicMng,
    element: <CommunityTopicMngPage />,
  },
  {
    path: PageLink.CommunityTopicSubmissions,
    element: <CommunityTopicSubmissionsPage />,
    hideInMenu: true,
  },
  // 社区管理 - 违禁词设置
  {
    path: PageLink.ForbiddenWord,
    element: <ForbiddenWordPage />,
  },

  // 工具页面
  {
    path: PageLink.ToolsImgUpload,
    element: <UploadImage />,
  },
  {
    path: PageLink.ToolsImageScraperUploader,
    element: <ImageScraperUploader />,
  },
  {
    path: PageLink.ToolsCrypto,
    element: <CryptoPage />,
  },
  // 资源位管理
  {
    path: PageLink.ResourcePosition,
    element: <ResourcePositionPage />,
  },

  // 资源位素材管理
  {
    path: PageLink.ResourceMaterial,
    element: <ResourceMaterialPage />,
  },
  {
    path: PageLink.ResourceMaterial,
    element: <ResourceMaterialPage />,
    query: { code: ':code' },
    hideInMenu: true,
  },
  {
    path: PageLink.ResourceMaterialDetail,
    element: <ResourceMaterialDetailPage />,
    hideInMenu: true,
    noPermissionRequired: true,
  },
  // 积分商城
  {
    path: PageLink.PointsMall,
    element: <PointsMallPage />,
  },
  {
    path: PageLink.PointsMallDetail,
    element: <PointsMallDetail />,
    hideInMenu: true,
  },
  // 商品管理
  {
    path: PageLink.Products,
    element: <ProductsPage />,
  },
  {
    path: PageLink.ProductsCreate,
    element: <ProductsCreate />,
  },
  {
    path: PageLink.ProductsEdit,
    element: <ProductsEdit />,
  },
  {
    path: PageLink.ProductsDetail,
    element: <ProductsDetail />,
  },
  // 订单管理
  {
    path: PageLink.Order,
    element: <OrderPage />,
  },
  {
    path: PageLink.Recharge,
    element: <RechargePage />,
  },
  // 版本管理
  {
    path: PageLink.VersionMng,
    element: <VersionMngPage />,
  },
  {
    path: PageLink.VersionMngAndroid,
    element: <VersionMngAndroidPage />,
  },
  {
    path: PageLink.VersionMngIos,
    element: <VersionMngIosPage />,
  },
  // 投票活动
  {
    path: PageLink.VoteActivity,
    element: <VoteActivityPage />,
  },
  {
    path: `${PageLink.VoteActivity}/create`,
    element: <VoteActivityCreate />,
    hideInMenu: true,
  },
  {
    path: `${PageLink.VoteActivity}/submissions/:id`,
    element: <VoteActivitySubmissions />,
    hideInMenu: true,
  },
  {
    path: PageLink.Improper,
    element: <Improper />,
  },
  {
    path: PageLink.PushMng,
    element: <PushMngPage />,
  },
  {
    path: `${PageLink.PushMng}/create`,
    element: <PushMngDetailPage />,
    hideInMenu: true,
  },
  {
    path: `${PageLink.PushMng}/detail/:id`,
    element: <PushMngDetailPage />,
    hideInMenu: true,
  },
  {
    path: PageLink.Recall,
    element: <RecallPage />,
  },
  {
    path: `${PageLink.Recall}/create`,
    element: <RecallCreatePage />,
    hideInMenu: true,
  },
  {
    path: `${PageLink.Recall}/detail/:id`,
    element: <RecallDetailPage />,
    hideInMenu: true,
  },
  // 活动管理
  // 抽奖活动
  {
    path: PageLink.LotteryActivity,
    element: <LotteryActivityPage />,
  },
  {
    path: `${PageLink.LotteryActivity}/create`,
    element: <LotteryActivityCreate />,
    hideInMenu: true,
  },
  {
    path: `${PageLink.LotteryActivity}/record`,
    element: <LotteryActivityRecord />,
    hideInMenu: true,
  },
  {
    path: PageLink.PromptUpload,
    element: <PromptUploadPage />,
  },
  {
    path: PageLink.BannerMng,
    element: <BannerMngPage />,
  },
  {
    path: `${PageLink.BannerMng}/create`,
    element: <BannerMngDetailPage />,
    hideInMenu: true,
  },
  {
    path: `${PageLink.BannerMng}/detail/:id`,
    element: <BannerMngDetailPage />,
    hideInMenu: true,
  },
  {
    path: PageLink.Liblib,
    element: <LiblibList />,
  },
  {
    path: `${PageLink.Liblib}/create`,
    element: <LiblibDetail />,
    hideInMenu: true,
  },
  {
    path: `${PageLink.Liblib}/detail/:id`,
    element: <LiblibDetail />,
    hideInMenu: true,
  },
  {
    path: PageLink.Convert,
    element: <ConvertList />,
  },
  {
    path: `${PageLink.Convert}/create`,
    element: <ConvertDetail />,
    hideInMenu: true,
  },
  {
    path: `${PageLink.Convert}/edit/:id`,
    element: <ConvertDetail />,
    hideInMenu: true,
  },
  {
    path: PageLink.NoticeConfig,
    element: <NoticeConfig />,
  },
  {
    path: `${PageLink.NoticeConfig}/create`,
    element: <NoticeConfigEdit />,
    hideInMenu: true,
  },
  {
    path: `${PageLink.NoticeConfig}/edit/:id`,
    element: <NoticeConfigEdit />,
    hideInMenu: true,
  },
  {
    path: `${PageLink.NoticeConfig}/detail/:id`,
    element: <NoticeConfigDetail />,
    hideInMenu: true,
  },
  // 会员管理
  {
    path: PageLink.MemberType,
    element: <MemberTypePage />,
  },
  {
    path: PageLink.MemberBenefit,
    element: <MemberBenefitPage />,
  },
  {
    path: PageLink.MemberSubscription,
    element: <MemberSubscriptionPage />,
  },
  {
    path: PageLink.MemberSuppId,
    element: <VipSuppIdPage />,
  },
  {
    path: PageLink.NewcomerChallenge,
    element: <NewcomerChallengePage />,
  },
  {
    path: `${PageLink.NewcomerChallenge}/detail/:id`,
    element: <NewcomerChallengeDetailPage />,
    hideInMenu: true,
  },
  {
    path: `${PageLink.NewcomerChallenge}/submissions/:id`,
    element: <NewcomerChallengeSubmissionsPage />,
    hideInMenu: true,
  },
  {
    path: PageLink.ActivityRules,
    element: <ActivityRulesPage />,
  },
  {
    path: `${PageLink.ActivityRules}/detail/:id`,
    element: <ActivityRuleDetailPage />,
    hideInMenu: true,
  },
  // 文生图风格
  {
    path: PageLink.TextToImageStyle,
    element: <TextToImageStylePage />,
  },
  // E15 限时任务管理
  {
    path: PageLink.LimitedTaskMng,
    element: <LimitedTaskMngPage />,
  },
];
